/*
 * Permite avanzar entre los campos de un formulario con la tecla Enter,
 * igual que con el tabulador. Pensado para agilizar la carga de datos.
 *
 * Uso: <div onKeyDown={enterComoTab}> ...campos... </div>
 *
 * - No interfiere con textareas (Enter = salto de línea) ni con botones
 *   (Enter = activar el botón).
 * - Solo considera campos visibles y habilitados.
 */
export const enterComoTab = (e) => {
    if (e.key !== 'Enter') {
        return
    }

    const origen = e.target
    const tag = origen?.tagName

    // Enter debe conservar su comportamiento natural en estos casos
    if (tag === 'TEXTAREA' || tag === 'BUTTON' || origen?.type === 'submit') {
        return
    }

    if (tag !== 'INPUT' && tag !== 'SELECT') {
        return
    }

    e.preventDefault()

    const campos = Array.from(
        e.currentTarget.querySelectorAll('input, select, textarea')
    ).filter((el) => !el.disabled && el.type !== 'hidden' && el.offsetParent !== null)

    const indice = campos.indexOf(origen)

    if (indice === -1 || indice >= campos.length - 1) {
        return
    }

    const siguiente = campos[indice + 1]
    siguiente.focus()

    // Si es un campo de texto, seleccionamos el contenido para poder sobreescribir directo
    if (typeof siguiente.select === 'function' && siguiente.tagName === 'INPUT') {
        siguiente.select()
    }
}
